import { createSelector } from '@ngrx/store';

import { ClientPolicyParticipants } from '@models/swagger';
import { State } from './reducer';
import { selectParticipantsState } from '../selectors';

export const getData = createSelector(selectParticipantsState, (state: State) => state.data);

export const getError = createSelector(selectParticipantsState, (state: State) => state.error);

export const getLoading = createSelector(selectParticipantsState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ClientPolicyParticipants[]) => T) =>
  createSelector(selectParticipantsState, (state: State) => fn(state.data));
